import dayjs from 'dayjs';

function isNullCheck(val: any) {
  if (val === null || val === undefined || val === '') return '';
  else return val;
}

function updatedStoreValue(store: any) {
  const value = {
    AccountsInfo: store.accountsInfo
      ?.map((item: any) => item)
      .sort((a: any, b: any) => a - b),

    SubmittedDate: isNullCheck(store?.extraCoverageRequestDet?.submittedDate),
    ReturnEmailAddress: isNullCheck(
      store?.extraCoverageRequestDet?.returnEmailAddress,
    ),
    AdditionalReturnEmailAddress: isNullCheck(
      store?.extraCoverageRequestDet?.AdditionalReturnEmailAddress,
    ),
    TimeZoneId:
      store?.extraCoverageRequestDet?.TimeZoneId === undefined ||
      store?.extraCoverageRequestDet?.TimeZoneId === '-1'
        ? -1
        : parseInt(store?.extraCoverageRequestDet?.TimeZoneId),
    ExtraCoverageDate: dayjs(
      isNullCheck(store?.extraCoverageRequestDet?.ExtraCoverageDate),
    ).format('MM/DD/YYYY'),
    OpensNextDayDate: dayjs(
      isNullCheck(store?.extraCoverageRequestDet?.OpensNextDayDate),
    ).format('MM/DD/YYYY h:mm A'),
    ClosesDayBeforeDate: dayjs(
      isNullCheck(store?.extraCoverageRequestDet?.ClosesDayBeforeDate),
    ).format('MM/DD/YYYY h:mm A'),
    StartTime: isNullCheck(store?.extraCoverageRequestDet?.StartTime).substring(
      0,
      5,
    ),
    EndTime: isNullCheck(store?.extraCoverageRequestDet?.EndTime).substring(
      0,
      5,
    ),
    ExtraCoverageRequestStatusId: parseInt(
      isNullCheck(store?.extraCoverageRequestDet?.ExtraCoverageRequestStatusId),
    ),
    ExtraCoverageRequestTypeId: store?.extraCoverageRequestDet
      ?.ExtraCoverageRequestTypeId
      ? parseInt(store?.extraCoverageRequestDet?.ExtraCoverageRequestTypeId)
      : 7,

    ReasonForCoverage: isNullCheck(
      store?.extraCoverageRequestDet?.ReasonForCoverage,
    ),
    SpecialProcedures: isNullCheck(
      store?.extraCoverageRequestDet?.SpecialProcedures,
    ),
    SpecialProcedureMemo: isNullCheck(
      store?.extraCoverageRequestDet?.SpecialProcedureMemo,
    ),
    SendEmailOnSave: isNullCheck(store?.sendEmailOnSave),
    PostAlertOnSave: isNullCheck(store?.postAlertOnSave),
    AdditionalComments: isNullCheck(
      store?.extraCoverageRequestDet?.AdditionalComments,
    ),
  };
  return value;
}
export { updatedStoreValue };
